export default "__VITE_ASSET__tWltgJfC__"